import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Form } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import SalesField from './SalesField';
import AnotherBankAccount from './AnotherBankAccount';
import SwitchingBankAccount from './SwitchingBankAccount';
import AccountNumber from './AccountNumber';
import SortCodeField from './SortCodeField';
import CostToStartBusiness from './CostToStartBusiness';
import FundsToStartBusiness from './FundsToStartBusiness';
import { isTradingLessThanSixMonths } from '../../../utils/validation';
import DateField from '../../../components/DateField';
import FocusHOC from '../../../components/FocusHOC';
import { checkEmptyFieldValue, onKeyPress } from '../../../utils';
import Submit from '../../../components/Submit';

class BusinessFinancePage extends Component {
  constructor(props) {
    super(props);
    this.saveBusinessFinanceForm = this.saveBusinessFinanceForm.bind(this);
  }
  saveBusinessFinanceForm(data) {
    const newData = {
      ...data,
      ...(data.annualSales && { annualSales: data.annualSales })
    };
    if (checkEmptyFieldValue(this.props.businessId)) {
      if (this.props.isSoleBusinessType) {
        this.props.saveBusinessUpdateForm(newData);
      } else {
        this.props.saveBusinessTaxUpdateForm(newData);
      }
    } else {
      this.props.saveBusinessFinanceForm(newData);
    }
  }
  render() {
    const { getBusinessData, decorators } = this.props;
    return (
      <Form
        onSubmit={this.saveBusinessFinanceForm}
        decorators={decorators}
        initialValues={getBusinessData}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit} onKeyPress={onKeyPress}>
            <>
              <Content>
                {({ businessFinance = '' }) => <PageHeading>{businessFinance}</PageHeading>}
              </Content>
              <SalesField formFieldValues={values} />
              <DateField dateHeader="beginTrading" />
              {values.beginTrading && isTradingLessThanSixMonths(values.beginTrading) && (
                <ConditionalPanel isVisible>
                  <CostToStartBusiness value={values.costToStartBusiness} />
                  <FundsToStartBusiness formFieldValues={values} />
                </ConditionalPanel>
              )}
              <AnotherBankAccount formFieldValues={values} />
              {values.anotherBankAccount === 'Yes' && (
                <SwitchingBankAccount formFieldValues={values} />
              )}
              {values.switchingBankAccount === 'Yes' && values.anotherBankAccount === 'Yes' && (
                <ConditionalPanel isVisible>
                  <Content>
                    {({ sortCodeSection = '', sortCodePara }) => (
                      <GenericFieldWrapper title={sortCodeSection}>
                        <p>{sortCodePara}</p>
                      </GenericFieldWrapper>
                    )}
                  </Content>

                  <SortCodeField />
                  <AccountNumber />
                </ConditionalPanel>
              )}
              <Submit />
            </>
          </form>
        )}
      />
    );
  }
}

BusinessFinancePage.propTypes = {
  saveBusinessFinanceForm: PropTypes.func.isRequired
};

export default FocusHOC(BusinessFinancePage);
